// ui
export const COOKIE_MAX_AGE = 60 * 60 * 24;
export const COOKIES = {
  AUTH: "wombat_auth_token",
};

export const DRAWER_WIDTH = 240;
export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";

export const EditorControlBarId = "editor-control-bar";

export const MEDIAQUERY = {
  mobile: "(max-width: 440px), (max-device-width: 440px)",
  mobile_p: "(min-width: 441px) and (min-device-width: 441px)",
  xs: "(max-width:599px)",
  sm: "(min-width:600px)",
  tablet: "(max-width: 950px), (max-device-width: 950px)",
  md: "(min-width:900px)",
  md_plus: "(min-width: 970px)",
  lg: "(min-width:1200px)",
  xl: "(min-width:1536px)",
};

// security
export const GROUPS = {
  ADMINISTRATORS: "administrators",
  SYSTEM_ADMINISTRATORS: "system-administrators",
  USERS: "users",
};

export enum SECURITY_PROFILE_NAMES {
  "administrators" = "administrators",
  "superadmins" = "superadmins",
  "user" = "user",
}

export enum SEAT_LIMIT_COUNTS {
  tear1 = 1,
  tear2 = 25,
  tear3 = 50,
  tear4 = 100,
}
// org admin
export const ORG_ICON_FILE_NAME = "org-icon.img";

// tenant admin
export const TENANT_ICON_FILE_NAME = "tenant-icon.img";
export const USER_ICON_FILE_NAME = "user-icon.img";
export const SITE_DIV_ICON_NAME = "client-icon.img";
export const CONTRACTOR_ICON_FILE_NAME = "contractor-icon.img";

// people
export const PEOPLE_PROFILE_PICTURE_FILE_NAME = "user-icon.png";

// form folders
export const ALL_FORMS_FOLDER = "all-forms-folder";
export const FAV_FOLDER = "fav-folder";
